import React, { useState } from "react";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

// 導航欄元件 - 包含 Logo、導航連結、語言切換、行動裝置選單
const Navbar = ({ t, locale, onLocaleChange }) => {
  // 控制行動裝置選單顯示
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNav = (id, path) => (e) => {
    e.preventDefault();
    setMenuOpen(false);
    const isOtherPage = window.location.pathname !== "/";
    window.history.pushState(null, "", path === "/" ? "/" : path);
    if (isOtherPage) {
      // 從子頁面回首頁，先切換頁面再滾動
      window.dispatchEvent(new PopStateEvent("popstate"));
      if (id === "top") {
        window.scrollTo(0, 0);
      } else {
        setTimeout(() => scrollTo(id), 150);
      }
    } else {
      if (id === "top") {
        window.scrollTo(0, 0);
      } else {
        scrollTo(id);
      }
    }
  };

  const handleSubPage = (path) => (e) => {
    e.preventDefault();
    setMenuOpen(false);
    window.history.pushState(null, "", path);
    window.dispatchEvent(new PopStateEvent("popstate"));
  };

  return (
    <nav className="navbar">
      <div className="container">
        {/* Logo */}
        <a href="/" onClick={handleNav("top", "/")} className="navbar-logo">
          <img src="/vapor-icon.svg" alt="Vapor" className="navbar-logo-icon" />
          VAPOR
        </a>

        {/* 漢堡選單按鈕（行動裝置） */}
        <button
          className="menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>

        {/* 導航連結 */}
        <ul className={`navbar-links ${menuOpen ? "open" : ""}`}>
          <li>
            <a href="/features" onClick={handleNav("features", "/features")}>
              {t.nav.features}
            </a>
          </li>
          <li>
            <a href="/privacy" onClick={handleNav("privacy", "/privacy")}>
              {t.nav.privacy}
            </a>
          </li>
          <li>
            <a href="/faq" onClick={handleSubPage("/faq")}>
              {t.nav.faq}
            </a>
          </li>

          {/* 語言切換 - 簡潔切換 */}
          <li className="lang-toggle">
            <button
              className={`lang-toggle-btn ${locale === "en" ? "active" : ""}`}
              onClick={() => onLocaleChange("en")}
            >
              EN
            </button>
            <span className="lang-toggle-sep">/</span>
            <button
              className={`lang-toggle-btn ${locale === "zh-TW" ? "active" : ""}`}
              onClick={() => onLocaleChange("zh-TW")}
            >
              中
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
